import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService } from 'src/app/tools/api.service';
import { ErrorService } from 'src/app/tools/error.service';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ColorUser } from 'src/app/models/coloruser';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from '../../tools/header.service';

@Component({
  selector: 'app-referentaccounts',
  templateUrl: './referentaccounts.component.html',
  styleUrls: ['./referentaccounts.component.scss']
})
export class ReferentaccountsComponent implements OnInit, OnDestroy {

  // pour les colonnes
  displayedColumnsS1 = ["status" , "mail", "name", "firstname", "socialReason", "address", "city", "country" , "info"];
  displayedColumns: string[];

  // pour les tab
  actualtab = '';
  actualpane = '';

  activationStatus1 : ColorUser[] = [];
  actualcoloruser: ColorUser[] = [];

  allAccountSub:any;
  allActivation: any[] = [];
  dataSource:any;
  actualid:number;

  constructor(private ApiService: IxellAPIService, private headerService: HeaderService, private errorService : ErrorService) { }

  ngOnInit() {
    Utils.deleteStorageData();
    this.headerService.changeTitle("common.compte");
    this.headerService.changeCanBack(true);
    this.allAccountSub = this.ApiService.getAllActivations().subscribe(data => {
      data.forEach(element => {
        this.activationStatus1.push(ColorUser.parseToColorUser(element));
        this.dataSource = new MatTableDataSource(this.activationStatus1);
        this.activationStatus1.sort((a, b) => { return compare(a.idcolorUser, b.idcolorUser, true); })
        this.displayedColumns = this.displayedColumnsS1;
        if (this.allAccountSub != null) this.allAccountSub.unsubscribe();
      });
    }, error => {
      this.errorService.setErrorLog("API", error.status.toString() + " " + error.message ,"allActivation", new Date().toString());
      if (this.allAccountSub != null) this.allAccountSub.unsubscribe();
    });
  }

  ngOnDestroy(){
    if (this.allAccountSub != null) this.allAccountSub.unsubscribe();
  }

  displayInfoModal(id: number){
    this.actualcoloruser = [];
    this.actualid = id;
    let modal = document.getElementById("modalInfo");
    modal.style.display = "block";
    let index = this.activationStatus1.findIndex(el => el.idcolorUser == id);
    this.actualcoloruser.push(this.activationStatus1[index]);
  }

  closeModal(){
    // Ferme la modal
    let modal = document.getElementById("modalInfo");
    modal.style.display = "none";
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  sortScale(sort: Sort, status: string) {
    // var data = this.activationLst;
    var data = this.activationStatus1;

    if (!sort.active || sort.direction === '') {
      return;
    }
    data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'status':
          return compare(a.accepted, b.accepted, isAsc);
        case 'activationDate':
          return compareDate(a.activationDate, b.activationDate, isAsc);
        case 'mail':
          return compare(a.mail, b.mail, isAsc);
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'firstname':
          return compare(a.firstname, b.firstname, isAsc);
        case 'phone':
          return compare(a.phone, b.phone, isAsc);
        case 'mobilePhone':
          return compare(a.mobilePhone, b.mobilePhone, isAsc);
        case 'socialReason':
          return compare(a.socialReason, b.socialReason, isAsc);
        case 'address':
          return compare(a.address, b.address, isAsc);
        case 'postalCode':
          return compare(a.postalCode, b.postalCode, isAsc);
        case 'city':
          return compare(a.city, b.city, isAsc);
        case 'country':
          return compare(a.country, b.country, isAsc);
        case 'refus':
          return compare(a.refusal, b.refusal, isAsc);
        default: return 0;
      }
    });
    this.activationStatus1 = data.slice();
    // this.activationSource = data.slice();
      this.dataSource = new MatTableDataSource(this.activationStatus1);
  }

}


function compare(a: number|string, b: number|string, isAsc: boolean) {
  if (a == null) return -1;
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function compareDate(a: string, b: string, isAsc: boolean) {
  if (a == null) return -1;
  var tmpa = a.split("/");
  var tmpb = b.split("/");
  a = tmpa[1] + "/" + tmpa[0] + "/" + tmpa[2];
  b = tmpb[1] + "/" + tmpb[0] + "/" + tmpb[2];

  return (new Date(a) < new Date(b) ? -1 : 1) * (isAsc ? 1 : -1);
}
